import React from 'react';
import type { FlexProps } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';

interface ContentGridContainerProps {
  showSideBar: boolean;
  marginTop?: FlexProps['marginTop'];
}

export const ContentGridContainer: React.FC<ContentGridContainerProps & FlexProps> = ({ children, showSideBar, marginTop = [7, null, 0], ...restProps }) => {
  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="flex-start"
      marginTop={marginTop}
      {...restProps}
    >
      {children}
    </Flex>
  );
};
